import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { UploadFilesComponent } from '../components/upload-Files/upload-files.component';
import { FilesViewComponent } from '../components/files-view/files-view.component';

@Injectable()
export class DialogService {
    constructor(private dialog: MatDialog) {}

    // Abre un diálogo de confirmación y devuelve una promesa con la respuesta de confirmación (true o false)
    openConfirmDialog(data: any): Promise<boolean> {
        // Abre el componente
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: data, // Datos adicionales que se pasan al componente de diálogo
            width: '40%', // Ancho del diálogo (40% del ancho disponible)
            disableClose: true, // Evita que el usuario cierre el diálogo haciendo clic fuera de él
            panelClass: data.class || 'info-alert',
        });

        // Devuelve una promesa que se resuelve cuando el diálogo se cierra
        return dialogRef.afterClosed().toPromise();
    }
    // Abre un diálogo de archivos y devuelve una promesa con la respuesta
    openFilesViewDialog(data: any): Promise<any> {
        // Abre el componente
        const dialogRef = this.dialog.open(FilesViewComponent, {
            data: data, // Datos adicionales que se pasan al componente de diálogo
            width: '85%', // Ancho del diálogo (60% del ancho disponible)
            disableClose: true, // Evita que el usuario cierre el diálogo haciendo clic fuera de él
        });
        return dialogRef.afterClosed().toPromise<any>();
    }

    // Abre un diálogo de paa subir archivos devuelve una promesa con la respuesta de los archivos creados
    openUploadDialog(data: any): Promise<any> {
        // Abre el componente
        const dialogRef = this.dialog.open(UploadFilesComponent, {
            data: data, // Datos adicionales que se pasan al componente de diálogo
            width: '40%', // Ancho del diálogo (40% del ancho disponible)
            disableClose: true, // Evita que el usuario cierre el diálogo haciendo clic fuera de él
        });
        return dialogRef.afterClosed().toPromise<any>();
    }
}
